import Centered from './primitives/Centered';
import CloseIcon from 'components/BaseShare/primitives/CloseIcon';
import Content from './primitives/Content';
import globalStyles from 'views/App/globalStyles';
import StandaloneWrapper from './primitives/StandaloneWrapper';
import Subtitle from './primitives/Subtitle';
import Title from './primitives/Title';
import { CloseButton as ClosePrimitive } from 'hooks/useModal/primitives';
import { Global } from '@emotion/react';
import type { FunctionComponent, ReactNode } from 'react';

// Intentionally defined inside this file to prevent usage elsewhere
const CloseButton = () => (
  <ClosePrimitive
    onClick={() => {
      window.location.href = '/';
      return false;
    }}
    type="button"
  >
    <CloseIcon />
  </ClosePrimitive>
);

type Props = {
  hideClose?: boolean;
  title: string;
  subtitle?: ReactNode;
};

const StandaloneView: FunctionComponent<Props> = ({
  children,
  hideClose,
  subtitle,
  title,
}) => {
  return (
    <>
      <Global styles={globalStyles} />
      <StandaloneWrapper>
        <Centered>
          <Content>
            {title && <Title>{title}</Title>}
            {subtitle && (
              <Subtitle css={{ marginTop: '0.5rem' }}>{subtitle}</Subtitle>
            )}
            {children}
            {!hideClose && <CloseButton />}
          </Content>
        </Centered>
      </StandaloneWrapper>
    </>
  );
};

export default StandaloneView;
